var map = {
	"./back.png": "4ea0",
	"./back_hover.png": "1f2d",
	"./correct.png": "1cb6",
	"./exit.png": "7d35",
	"./exit_hover.png": "02f3",
	"./frame_hover.png": "8709",
	"./info.png": "9f8c",
	"./info_hover.png": "da336",
	"./no.png": "08f0",
	"./no_hover.png": "8945",
	"./ok.png": "f88e",
	"./ok_disable.png": "64a3",
	"./ok_hover.png": "ed62",
	"./play.png": "eb32",
	"./play_hover.png": "2e6d",
	"./white.png": "a95d",
	"./white_hover.png": "4d41",
	"./yes.png": "c113",
	"./yes_hover.png": "b4eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6316";